import { twMerge } from 'tailwind-merge';
import useIsMobileView from '../../../hooks/useIsMobileView';
import Avatar from '../../../features/avatar/Avatar';
import Button, { ButtonVariants } from '../../../components/new-design/Button';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../routers/Routes';
import { usePrivy } from '@privy-io/react-auth';

interface KycPendingProps {
  userId: string;
}

const KycPending = ({ userId }: KycPendingProps) => {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();
  const { logout, authenticated } = usePrivy();

  const handleBackToLogIn = async () => {
    if (authenticated) await logout();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  const handleEditAvatar = () => navigate(ROUTES.AVATURN, { replace: true });

  return (
    <div className="my-10 flex h-full items-center justify-center">
      <div
        className={`mx-auto ${
          isMobileView
            ? `h-full w-full`
            : `z-100 max-w-[570px] gap-0 rounded-[30px] bg-phenom-background-modal-out p-[1px] text-white`
        }`}
      >
        <div
          className={twMerge('left-4 w-full rounded-[30px] bg-phenom-border-glow p-[1px]', isMobileView && 'w-screen')}
        >
          <div className={twMerge('h-full w-full rounded-[30px] bg-ph-background-dark p-8')}>
            <div className="flex flex-col items-center gap-7 text-center">
              <div className="h-40 w-40 rounded-full bg-phenom-border-glow p-[1px]">
                <Avatar userId={userId} className="h-40 w-40" />
              </div>

              <div className="flex flex-col items-center justify-center gap-1">
                <h1 className="text-2xl text-ph-gray-white">KYC Status</h1>
                <p className="text-base font-normal text-ph-gray-silver">
                  Your submission is being processed. Please come back later.
                </p>
              </div>

              <div className={twMerge('flex w-full items-center justify-center gap-2', isMobileView && 'flex-col')}>
                <Button
                  type="button"
                  variant={ButtonVariants.secondary}
                  onClick={handleBackToLogIn}
                  className="border-ph-primary-violet bg-ph-background-dark capitalize text-ph-primary-violet"
                  fullWidth
                >
                  Back to Log In
                </Button>

                <Button type="button" onClick={handleEditAvatar} fullWidth>
                  Edit Avatar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycPending;
